export function ReviewTitle() {
  return (
    <>
      <div className="review__description--top">
        <strong>Produto</strong>
      </div>
      <div className="review__size--top">
        <strong>Tamanho escolhido</strong>
      </div>
      <div className="review__value--top">
        <strong>Valor</strong>

      </div>
      <div className="review__amount--top">
        <strong>Quantidade</strong>

      </div>
      <div className="review__subtotal--top">
        <strong>Subtotal</strong>
      </div>
    </>
  );
}